const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            isCMS: '1',
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: {},
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async getItems({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/misc-expenses`, {params:params})
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                response.data.data.pages = params
                commit( 'setListItems', response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        if (params.id == 0  ) {
            commit('setItem', []);
            return;
        } 
        commit( 'setLoadings', {key:"detail",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/misc-expenses/${params.id}`)
            .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                commit( 'setItem', response.data.data );
                resolve( response );
            })
            .catch(error => {
                commit( 'setLoadings', {key:"detail",val:false});
                reject( error );
            });
        });
    },
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/misc-expenses`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/misc-expenses/${params.id}`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deteleItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`/api/misc-expenses`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async uploadAttachment({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('attachment', params.attachment);
          global.axios(`/api/misc-expenses/attachments/${params.id}`, {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              data : formData
          })
          .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
    async createAttachment({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          formData.append('photos[0]', params.attachment);
          global.axios(`/api/attachments`, {
              method: "POST",
              headers: {
                Accept: "application/json",
              },
              data : formData
          })
          .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
      async removeAttachments({commit},params){
        return new Promise (( resolve, reject ) => {
          global.axios(`/api/attachments`, {
              method: "DELETE",
              headers: {
                Accept: "application/json",
              },
              data : params
          })
          .then(response => {
             resolve( response );
          })
          .catch(error => reject( error ));
        });
      },
      async updateAttachments({commit,state},params){
        return new Promise (( resolve, reject ) => {
          let formData = new FormData();
          if(params.attachment)
            formData.append('attachment', params.attachment);
            formData.append('attachment_id', params.attachment_id );
            global.axios(`api/misc-expenses/attachments/${params.id}`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
                data : formData
            })
            .then(response => {
              commit( 'setLoadings', {key:"detail",val:false})
              resolve( response );
            })
            .catch(error => reject( error ));
          });
      },
      async getReferences({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/references`, {params: params})
            .then(response => {
                response.data.data.pages = params
                resolve( response );
            })
            .catch(error => reject( error ));
        });
      },
      async getRelateSupplier({commit}, params){

        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/organizations/relate-supplier-misc`,{params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async exportItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/misc-expenses/export`, {params:params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    }
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setItem (state, data) {
        state.Item = data;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}